import React, { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  makeStyles,
  TextField,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { http } from "../../network";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import AppBarComp from "../../components/AppBar";
import { getCookie, isDevMode } from "../../utils";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "90vh",
      background:
        "radial-gradient(circle, rgba(187,187,187,1) 2%, rgba(112,114,116,1) 100%)",
    },
    container: {
      height: "100%",
    },
    qWidth: {
      width: "25%",
      marginBottom: 8,
    },
    floatingLabelFocusStyle: {
      color: theme.palette.main,
    },
  };
});

const LoginPage = () => {
  const classes = useStyles();
  const [showPassword, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const loggedInFromOne = getCookie("instalimb_token");
    if (loggedInFromOne) navigate("/");
  }, [document.cookie]);

  const attemptLogin = async () => {
    const body = {
      email,
      password,
    };
    try {
      const login = await http.post("/login", body);
      toast(login?.data?.message);
      const token = login?.data?.token;
      localStorage.setItem("instalimb_token", token);
      localStorage.setItem("modeler_email", login?.data?.user?.email);
      localStorage.setItem("modeler_role", login?.data?.user?.role);
      const domain = isDevMode() ? "localhost" : ".instalimb.com";
      document.cookie = `${"instalimb_token"}=${token}; domain=${domain}`;
      navigate("/");
    } catch (error) {
      toast(error?.response?.statusText);
    }
  };

  const goToForgot = () => {
    navigate("/forgot");
  };

  return (
    <>
      <AppBarComp />
      <Box component={"div"} className={classes.root}>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          className={classes.container}
        >
          <Grid item className={classes.qWidth}>
            <TextField
              autoComplete="off"
              fullWidth
              required
              label="Username / Email"
              variant="outlined"
              type={"email"}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>
          <Grid item className={classes.qWidth}>
            <TextField
              autoComplete="off"
              fullWidth
              label="Password"
              variant="outlined"
              type={showPassword ? "text" : "password"}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShow(!showPassword)}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid style={{ marginBottom: 1 }}>
            <Button onClick={goToForgot} loading variant="link">
              Forgot Password?
            </Button>
          </Grid>
          <Grid>
            <Button
              disabled={!email || !password}
              onClick={attemptLogin}
              loading
              variant="contained"
              color="primary"
            >
              Sign in
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default LoginPage;
